<header class="header">
  <div class="mission-info">
    <button type="button" class="info-button" (click)="navigateToMissionInfo()" [title]="'MISSION.INFORMATION' | translate">
      <ng-icon name="heroInformationCircle" size="22"/>
    </button>
    <div class="name">
      <span class="eyebrow">{{ 'MISSION.LABEL' | translate }}</span>
      <span class="mission-name">{{ mission ? mission.missionName : ('MISSION.NO_MISSION' | translate) }}</span>
    </div>
  </div>

  @if (mission && mission.checkingIsDone) {
    <div class="warning">
      <ng-icon name="heroExclamationTriangle" size="18"/>
      <span>{{ 'MISSION.MISSION_IN_PROGRESS' | translate }}</span>
    </div>
  }

  @if (mission) {
    <nav class="sections">
      <button type="button" class="section" (click)="navigateToTeam()">
        <ng-icon name="heroUserGroup" size="18"/>
        <span>{{ 'MISSION.TEAM' | translate }}</span>
        <span class="status-dot" [ngClass]="getStatusClass(mission.teamstatus, false)"></span>
      </button>
      <button type="button" class="section" (click)="navigateToProduct()">
        <ng-icon name="heroTruck" size="18"/>
        <span>{{ 'MISSION.PRODUCT' | translate }}</span>
        <span class="status-dot" [ngClass]="getStatusClass(mission.productstatus, true)"></span>
      </button>
      <button type="button" class="section" (click)="navigateToMaterial()">
        <ng-icon name="heroWrenchScrewdriver" size="18"/>
        <span>{{ 'MISSION.MATERIAL' | translate }}</span>
        <span class="status-dot" [ngClass]="getStatusClass(mission.materialstatus, true)"></span>
      </button>
      <button type="button" class="section" (click)="navigateToSupport()">
        <ng-icon name="heroLifebuoy" size="18"/>
        <span>{{ 'MISSION.SUPPORT' | translate }}</span>
        <span class="status-dot" [ngClass]="getStatusClass(mission.supportstatus, false)"></span>
      </button>
    </nav>
  }
</header>

<div class="content">
  @if (mission) {
    <router-outlet></router-outlet>
  }
</div>
